import React from 'react';
export function SalesFooter() {
  return <footer className="bg-slate-950 py-12 px-4 text-center border-t border-slate-900" data-id="element-112">
      <div className="max-w-4xl mx-auto" data-id="element-113">
        <p className="text-slate-500 text-sm leading-relaxed mb-4" data-id="element-114">
          Este producto no reemplaza el consejo médico profesional. Si tienes
          condiciones médicas preexistentes, consulta a tu doctor antes de
          iniciar cualquier nuevo régimen. Los resultados pueden variar de una
          persona a otra.
        </p>
        <p className="text-slate-600 text-xs" data-id="element-115">
          &copy; {new Date().getFullYear()} Duerme Profundo Hoy. Todos los
          derechos reservados.
        </p>
      </div>
    </footer>;
}